/**
 * Shared by every "time ago" label in the app (chat, notifications,
 * listings) — extracted from what `NotificationListItem` already did
 * inline, rather than each place re-implementing its own version (which is
 * how `ConversationListItem` ended up showing an absolute clock time/date
 * instead of "Xm ago" while this one didn't). Falls back to an absolute
 * "Mon Day" date past a week, since "52d ago" stops being a useful measure
 * of recency at that point.
 */
export function formatRelativeTime(iso: string): string {
  const date = new Date(iso);
  const diffMs = Date.now() - date.getTime();
  const diffMinutes = Math.floor(diffMs / 60_000);
  if (diffMinutes < 1) return "Just now";
  if (diffMinutes < 60) return `${diffMinutes}m ago`;
  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}
